<h1 mat-dialog-title>Windchill Confirmation</h1>
<div mat-dialog-content>
  <p>Check Windchill for most recent version before loading</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onClick(true)" cdkFocusInitial>Confirm</button>
  <button mat-button (click)="onClick(false)">Cancel</button>
</div>
